import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  deleteBgMaster,
  listBgMasters,
} from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * BG マスタ削除 mutation hook。
 * onSuccess で list query を invalidate してテーブルを最新化する。
 * optimistic locking: expected_updated_at を request に含める。
 */
export function useDeleteBgMaster(): InvalidatingMutationResultFor<
  typeof deleteBgMaster
> {
  return useInvalidatingMutation(deleteBgMaster, [
    createConnectQueryKey({ schema: listBgMasters, cardinality: 'finite' }),
  ])
}
